import Swiper, {
  Pagination,
  Lazy,
  Parallax,
  Autoplay,
  Navigation,
  Thumbs,
} from 'swiper';
import 'swiper/css';

export default function SingleOffer() {
  var aricleOffer = document.querySelector( 'article.offer' );
  if (aricleOffer) {
    showOfferMap();
    sliderGallery();
    sliderPlans();
    selectedOfferInForm();
  }
}

function sliderGallery() {
  Swiper.use( [Pagination, Lazy, Parallax, Autoplay, Navigation, Thumbs] );
  var swiperThumbs;
  if (document.querySelector( '.offer__gallery-thumbs-swiper' )) {
    swiperThumbs = new Swiper(
        '.offer__gallery-thumbs-swiper.offer-gallery-thumbs', {
          freeMode: true,
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },
          spaceBetween: 6,
          slidesPerView: 8,
          preloadImages: true,
          lazy: {
            loadPrevNext: true,
          },
          parallax: true,
        } );
  }
  if (document.querySelector( '.offer__gallery-swiper' )) {
    const swiper = new Swiper( '.offer__gallery-swiper.offer-gallery', {
      speed: 800,
      loop: true,
      autoplay: false,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      preloadImages: true,
      lazy: {
        loadPrevNext: true,
      },
      parallax: true,
      navigation: {

        nextEl: '.offer-gallery__nav--next',
        prevEl: '.offer-gallery__nav--prev',
      },
      thumbs: {
        swiper: swiperThumbs,
      },
    } );
  }

}

function sliderPlans() {
  Swiper.use( [Pagination, Lazy, Parallax, Autoplay, Navigation, Thumbs] );
  var swiperPlansThumbs;
  if (document.querySelector( '.offer__plans-thumbs-swiper' )) {
    swiperPlansThumbs = new Swiper( '.offer__plans-thumbs-swiper', {
      freeMode: true,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      spaceBetween: 6,
      slidesPerView: 8,
      preloadImages: true,
      lazy: {
        loadPrevNext: true,
      },
      parallax: true,
    } );
  }
  if (document.querySelector( '.offer__plans-swiper' )) {
    const swiperPlans = new Swiper( '.offer__plans-swiper.offer-gallery', {
      speed: 800,
      loop: true,
      autoplay: false,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      preloadImages: true,
      lazy: {
        loadPrevNext: true,
      },
      parallax: true,
      navigation: {

        nextEl: '.offer-plans__nav--next',
        prevEl: '.offer-plans__nav--prev',
      },
      thumbs: {
        swiper: swiperPlansThumbs,
      },
    } );
  }

}

function showOfferMap() {
  // var lat = document.querySelector( '#maposm' ).dataset.lat;
  // var lng = document.querySelector( '#maposm' ).dataset.lng;
  var mapContainer = document.querySelector( '#maposm' );
  if (mapContainer) {
    var approxLat = mapContainer.dataset.approx_lat;
    var approxLng = mapContainer.dataset.approx_lng;
    //var marker_uri = mapContainer.dataset.marker_uri;
    // definiujemy mapę po ID
    var map = L.map( 'maposm', {dragging: true, trackResize: false} ).
        setView( [approxLat, approxLng], 14 );

    // wyłączamy scroll
    map.scrollWheelZoom.disable();

    // dodajemy szablon mapy
    L.tileLayer( 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abc',
      maxZoom: 19,
    } ).addTo( map );

    // definiujemy marker
    // var icon = L.icon( {
    //   iconUrl: marker_uri,
    //   shadowUrl: '',
    //
    //   iconSize: [36, 48],
    //   shadowSize: [0, 0],
    //   iconAnchor: [18, 48],
    //   shadowAnchor: [0, 0],
    //   popupAnchor: [-3, -76],
    // } );

    // dodajemy marker na mapę
    // //var marker = L.circleMarker( [lat, lng], {radius: 100}).addTo( map );
    // console.log( [lat, lng] );
    // var marker = L.circle( [lat, lng], {radius: 400} ).addTo( map );
    var marker_approx = L.circle( [approxLat, approxLng], {radius: 400} ).
        addTo( map );
  }
}

function selectedOfferInForm() {
  var selectedOfferField = document.querySelector('textarea[name="selected_offer"]');
  var selectedOfferSource = document.querySelector('.selected-offer-source');
  if(selectedOfferField && selectedOfferSource) {
    selectedOfferField.innerHTML = selectedOfferSource.innerHTML;
  }
}
